module.exports = __webpack_public_path__ + "images/thumbs-up-old0c9d5dfe232ead3bd44f67195cbbae45.svg";